import React from "react";
import { FaGithub, FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";
import Logo from "../assets/Images/PNGIA.png"; // Assurez-vous que le chemin est correct

const Footer = () => {
  return (
    <footer className="bg-darkblue text-white text-center py-6 md:py-8">
      <div className="container mx-auto px-4">
        {/* Footer Top Section */}
        <div className="flex flex-col items-center space-y-4">
          {/* Logo Section */}
          <div className="mb-2">
            <img
              src={Logo}
              alt="Logo Imali Azzeddine"
              className="mx-auto w-12 h-12 md:w-16 md:h-16"
            />
          </div>

          <h2
            data-aos="fade-up"
            data-aos-duration="1000"
            className="text-xl md:text-2xl font-bold"
          >
            IMALI AZZEDDINE
          </h2>
          <p
            data-aos="fade-up"
            data-aos-duration="1200"
            className="text-sm md:text-lg text-gray-300"
          >
            AI Engineer | Software Developer | IT Project Manager
          </p>
          {/* Social Media Icons */}
          <div
            data-aos="fade-up"
            data-aos-duration="1400"
            className="flex space-x-6 text-lg md:text-xl"
          >
            <a
              href="https://github.com/azedin"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-orange-500 transition duration-300"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/imaliazzeddine/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-500 transition duration-300"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/1Xf8wwX1Sa/?mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 transition duration-300"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/im1zdn_/profilecard/?igsh=cnZzd2VobmowcGZ3"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-pink-500 transition duration-300"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div
          data-aos="fade-up"
          data-aos-duration="1600"
          className="mt-6 text-gray-400 text-sm md:text-md"
        >
          <p>
            © {new Date().getFullYear()} Azzeddine Imali. All rights reserved.
          </p>
          <p>
            Designed and developed with{" "}
            <span className="text-red-500">&hearts;</span> by Azzeddine Imali.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
